import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import type { CoffeeRateInterface } from '../types';

interface CardFooterProps {
    coffeeData: CoffeeRateInterface;
}

const ADMIN_UNDISCLOSED = 'admin-undisclosed';

const formatLocation = (data: CoffeeRateInterface): string => {
    if (data.isSelfMade) {
        if (
            data.location.city && data.location.country &&
            data.location.city !== ADMIN_UNDISCLOSED && data.location.country !== ADMIN_UNDISCLOSED
        ) {
            return `${data.location.city}, ${data.location.country}`;
        }
        return '';
    }
    const ref = data.coffeeShopRef;
    if (ref?.city && ref?.country) return `${ref.city}, ${ref.country}`;
    return `${data.location.city}, ${data.location.country}`;
};

const formatDate = (iso?: string): string => {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
};

export const CardFooter: React.FC<CardFooterProps> = ({ coffeeData }) => {
    const location = formatLocation(coffeeData);
    const dateLabel = formatDate(coffeeData.date);

    const tweetUrl = coffeeData.tweet?.tweetUrl;
    const hasTweet = !!tweetUrl;
    const onTweet = () => {
        if (tweetUrl) window.open(tweetUrl, '_blank');
    };

    return (
        <div className='details-container'>
            <div className='location-info'>
                {location && <div className='location'>{location}</div>}
                <div className='details-row'>
                    <div className='details-left'>
                        {hasTweet ? (
                            <div className='tweet' onClick={onTweet}>
                                <FontAwesomeIcon icon={faXTwitter} className='twitter-icon' />
                                View on X
                            </div>
                        ) : (
                            <div
                                className='tweet tweet--pending'
                                title='X post is still being published — refresh in a moment.'
                                aria-disabled
                            >
                                <FontAwesomeIcon icon={faXTwitter} className='twitter-icon' />
                                Pending…
                            </div>
                        )}
                    </div>
                    <div className='date'>{dateLabel}</div>
                </div>
            </div>
        </div>
    );
};
